import TableHead from '@material-ui/core/TableHead';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderGroup from './HeaderGroup';

const Head = ({ headerGroups, hasActions, headerStyle }) => (
  <TableHead>
    {headerGroups.map((headerGroup) => {
      const { key } = headerGroup.getHeaderGroupProps();
      return <HeaderGroup key={key} headerGroup={headerGroup} hasActions={hasActions} headerStyle={headerStyle} />;
    })}
  </TableHead>
);

Head.propTypes = {
  hasActions: PropTypes.bool,
  headerGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  headerStyle: PropTypes.shape(),
};

Head.defaultProps = {
  hasActions: false,
  headerStyle: undefined,
};

export default Head;
